<template>
  <b-card>
    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-year`"
            >Year <span class="danger-new"> *</span></label
          >
          <b-form-select
            v-model="form.year"
            :options="select.year"
            class="input-year"
            required
            @change="getMF(form.year)"
          ></b-form-select>
        </b-form-group>
      </b-col> </b-row
    ><br />

    <!-- TABLE -->

    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
      id="my-table"
    >
      <template v-slot:cell(index)="data">
        {{ pagination.startIndex + data.index }}
      </template>
      <template v-slot:cell(month)="data">
        <span v-if="data.value == '1'">January</span>
        <span v-if="data.value == '2'">February</span>
        <span v-if="data.value == '3'">March</span>
        <span v-if="data.value == '4'">April</span>
        <span v-if="data.value == '5'">May</span>
        <span v-if="data.value == '6'">June</span>
        <span v-if="data.value == '7'">July</span>
        <span v-if="data.value == '8'">August</span>
        <span v-if="data.value == '9'">September</span>
        <span v-if="data.value == '10'">October</span>
        <span v-if="data.value == '11'">November</span>
        <span v-if="data.value == '12'">December</span>
      </template>
      <template v-slot:cell(status)="data">
        <span v-if="data.value == '1'">Approved</span>
        <span v-if="data.value == '2'">Pending</span>
        <span v-if="data.value == '3'">Rejected</span>
        <span v-if="data.value == '4'">Draft</span>
        <span v-if="data.value == '5'">Completed</span>
      </template>
      <template v-slot:cell(action)="data">
        <!-- <span v-if="status == '4'">
          <b-button
            variant="primary"
            size="sm"
            @click="onClickView(data.item.id)"
          >
            {{ data.value.id }}VIEW
          </b-button>
        </span> -->
        <span v-if="data.item.status == '4' || data.item.status == null">
          <b-button
            variant="primary"
            size="sm"
            @click="onClickEdit(data.item.id)"
          >
            EDIT
          </b-button>
        </span>
        <span v-if="data.item.status == '5'">
          <b-button
            variant="primary"
            size="sm"
            @click="onClickView(data.item.id)"
          >
            VIEW
          </b-button>
        </span>
      </template>
    </b-table>

    <b-pagination
      v-model="pagination.current"
      :total-rows="pagination.total"
      :per-page="pagination.perPage"
      @change="onChangePage"
    ></b-pagination
    ><br />

    <b-row align="right">
      <b-col>
        <b-button
          variant="primary"
          size="sm"
          @click="onClickCreate"
          :disabled="items.length < 1 && select.year.length > 1"
          >CREATE MONTHLY FORECAST FOR {{ tempMonthWord }} {{ tempYear }}
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import moment from "moment";
import MonthFormatHelper from "@/helpers/MonthFormatHelper";

export default {
  data() {
    return {
      items: [],
      tempYear: moment().year(),
      tempMonth: moment().month() + 1,
      tempMonthWord: moment()
        .add(1)
        .format("MMM"),
      form: {
        year: ""
      },
      select: {
        year: []
      },
      pagination: {
        total: 0,
        current: 1,
        perPage: 10,
        startIndex: 0
      }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  mounted() {},
  created() {
    // this.getMF()
    this.getYear();
  },
  props: {
    fields: {
      type: Array,
      required: true
    }
  },
  methods: {
    onClickView(id, pro_cat) {
      this.$router.push({ path: `mf_view?id=${id}&cat=3&pro_cat=${pro_cat}` });
    },
    onClickShowCat() {
      this.$bvModal.show("choose-category");
    },
    onClickCreateJan() {
      this.$router.push({
        path: `mf_edit?type=new&month=january`
      });
    },
    onClickCreate() {
      let len = this.items.length;

      if (len >= 1) {
        this.$router.push({
          path: `mf_edit?type=new&month=${this.tempMonth}&year=${this.tempYear}`
        });
      } else {
        this.$router.push({
          path: `mf_edit?type=new&month=${this.tempMonth}&year=${this.tempYear}`
        });
      }
      this.$bvModal.hide("choose-category");
    },
    onClickEdit(id) {
      this.$router.push({
        path: `mf_edit?id=${id}&type=edit`
      });
    },
    close() {
      this.$bvModal.hide("choose-category");
    },
    getYear() {
      this.$store.dispatch("getYear").then(res => {
        this.select.year.push({
          text: "Please select",
          value: ""
        });
        if (res.data.response && res.data.response.code === 100) {
          res.data.data.forEach(item => {
            this.select.year.push({
              text: item.year,
              value: item.year
            });
          });
        }
      });
    },
    getMF(data) {
      this.items = [];
      let url = `year=${data}&page=${this.pagination.current}`;
      this.$store.dispatch("getMF", url).then(res => {
        res.data.data.data.forEach((element, index) => {
          if (index === 0) {
            if (element.month == 11) {
              let nextData = moment("2025-12-01").add(1, "M");
              this.tempMonth = nextData.format("M");
              this.tempYear = nextData.format("YYYY");
            } else {
              const monthYear = MonthFormatHelper.getValidMonthYear(Number(element.month + 1), Number(element.year))
              this.tempMonth = monthYear.month;
              this.tempYear = monthYear.year;
            }

            this.tempMonthWord = moment()
              .month(this.tempMonth - 1)
              .format("MMMM");
          }
          this.items.push({
            month: element.month,
            status: element.status,
            id: element.fc_id,
            type: element.type
          });
        });
        this.pagination.total = res.data.data.total;
        this.pagination.current = res.data.data.current_page;
        this.pagination.perPage = res.data.data.per_page;
        this.pagination.startIndex = res.data.data.from;
      });
    },
    onChangePage(index) {
      this.pagination.current = index;
      let data = this.form.year;
      this.getMF(data);
    }
  }
};
</script>
<style lang="css" scoped></style>
